// extracted by mini-css-extract-plugin
export default {"ellipsis":"Spinner_ellipsis__N4Vio","ellipsis1":"Spinner_ellipsis1__kbeB2","ellipsis2":"Spinner_ellipsis2__0fQU8","ellipsis3":"Spinner_ellipsis3__ENsru"};